export const locale = {
    lang: 'en',
    data: {
        'PROFILE': {
            'ACTUALIZAR': 'ACTUALIZAR',
            'PAYMENT': 'Payment Method',
            'PAYMENTNEW': 'Payment Method will be Updated!',
            'CARD': 'Card Data',
            'DATOS_PERSONALES': 'Personal Data',
            'PASSWORD_TAB': 'Security',
            'PASSWORD_TITLE': 'Password Change',
            'PASSWORD_OLD': 'Old Password',
            'PASSWORD_NEW': 'New Password',
            'EMAIL': 'Email',
            'EMAIL_REQUIRED': 'Email is required',
            'EMAIL_NOT_VALID': 'Please enter a valid email address',
            'PASSWORD': 'Password',
            'PASSWORD_REQUIRED': 'Password is required',
            'PASSWORD_CONFIRMATION': 'Password (Confirm)',
            'PASSWORD_CONFIRMATION_REQUIRED': 'Password confirmation is required',
            'PASSWORD_CONFIRMATION_MATCH': 'Passwords must match',
            'BUSINESS_NAME': 'Business Name',
            'BUSINESS_NAME_REQUIRED': 'Business name is required',
            'VAT_NUMBER': 'VAT Number',
            'VAT_NUMBER_REQUIRED': 'VAT Number is required',
            'PHONE_1': 'Phone 1',
            'PHONE_1_REQUIRED': 'Phone 1 is required',
            'PHONE_2': 'Phone 2 (optional)',
            'TRADENAME': 'Tradename',
            'TRADENAME_REQUIRED': 'Tradename required',
            'BILLING_ADDRESS': 'Billing Address',
            'BILLING_ADDRESS_REQUIRED': 'Billing Address required',
            'WEB': 'Web (optional)',
            'PROMOTIONAL_CODE': 'Promotional code (optional)',
            'READ_AND_ACCEPT': 'I read and accept',
            'TEMRS_AND_CONDITIONS': 'terms and conditions',
            'HAVE_ACCOUNT': 'Already have an account?',
            'LOGIN': 'Login',
            'PAYMENT_CARD_NUMBER': 'Credit card number',
            'PAYMENT_CARD_MONTH': 'Expiration month',
            'PAYMENT_CARD_YEAR': 'Expiration year',
            'PAYMENT_CARD_CVV': 'CVV',
            'PAYMENT_ADVISE': '*Payment will be made after the trial month',
            'CONTACT_DATA': 'Contact data (optional)',
            'CONTACT_NAME': 'Contact name',
            'CONTACT_EMAIL': 'Contact email',
            'PAYMENT_CARD_NOT_VALID': 'Card number not valid',
            'CARD_YEAR_REQUIRED': 'Year required',
            'PAYMENT_CARD_YEAR_NOT_VALID': 'Year not valid',
            'PAYMENT_CARD_DATE_NOT_VALID': 'Date not valid',
            'CARD_MONTH_REQUIRED': 'Month required',
            'PAYMENT_CARD_MONTH_NOT_VALID': 'Month not valid',
            'CARD_NUMBER_REQUIRED': 'Card number required',
            'CARD_CVV_REQUIRED': 'CVV required',
            'SUBSCRIPTION':'Go to My Subscription'
        },
        'REGISTER': {
            'TITLE': 'PERSONAL DATA',
            'ACTUALIZAR': 'UPDATE DATA',
            'EMAIL': 'Email',
            'EMAIL_REQUIRED': 'Email is required',
            'EMAIL_NOT_VALID': 'Please enter a valid email address',
            'PASSWORD': 'Password',
            'PASSWORD_REQUIRED': 'Password is required',
            'PASSWORD_CONFIRMATION': 'Password (Confirm)',
            'PASSWORD_CONFIRMATION_REQUIRED': 'Password confirmation is required',
            'PASSWORD_CONFIRMATION_MATCH': 'Passwords must match',
            'BUSINESS_NAME': 'Business Name',
            'BUSINESS_NAME_REQUIRED': 'Business name is required',
            'VAT_NUMBER': 'VAT Number (read Only)',
            'VAT_NUMBER_REQUIRED': 'VAT Number is required',
            'PHONE_1': 'Phone 1',
            'PHONE_1_REQUIRED': 'Phone 1 is required',
            'PHONE_2': 'Phone 2 (optional)',
            'TRADENAME': 'Tradename',
            'TRADENAME_REQUIRED': 'Tradename required',
            'BILLING_ADDRESS': 'Billing Address',
            'BILLING_ADDRESS_REQUIRED': 'Billing Address required',
            'WEB': 'Web (optional)',
            'PROMOTIONAL_CODE': 'Promotional code (optional)',
            'READ_AND_ACCEPT': 'I read and accept',
            'TEMRS_AND_CONDITIONS': 'terms and conditions',
            'HAVE_ACCOUNT': 'Already have an account?',
            'LOGIN': 'Login',
            'PAYMENT_CARD_NUMBER': 'Credit card number',
            'PAYMENT_CARD_MONTH': 'Expiration month',
            'PAYMENT_CARD_YEAR': 'Expiration year',
            'PAYMENT_CARD_CVV': 'CVV',
            'PAYMENT_ADVISE': '*Payment will be made after the trial month',
            'CONTACT_DATA': 'Contact data (optional)',
            'CONTACT_NAME': 'Contact name',
            'CONTACT_EMAIL': 'Contact email',
            'PAYMENT_CARD_NOT_VALID': 'Card number not valid',
            'CARD_YEAR_REQUIRED': 'Year required',
            'PAYMENT_CARD_YEAR_NOT_VALID': 'Year not valid',
            'PAYMENT_CARD_DATE_NOT_VALID': 'Date not valid',
            'CARD_MONTH_REQUIRED': 'Month required',
            'PAYMENT_CARD_MONTH_NOT_VALID': 'Month not valid',
            'CARD_NUMBER_REQUIRED': 'Card number required',
            'CARD_CVV_REQUIRED': 'CVV required'
        },
        'ADMIN': {
            'UPDATEOK':'Datos actualizados con éxito.',
            'UPDATEBAD':'Error al Actualizar Cliente'
        }
    }
};
